export default __webpack_public_path__ + "static/Ali_zaid_Brothers-090b5e0b8d1dfc264c1133874b2da993.jpg";